import { Component, Input, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
    FormControl,
} from '@angular/forms';
import { UserService } from '../user.service';
import { UserTokenService } from 'src/app/services/user-token.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/services/shared.service';
import { ResetPasswordComponent } from 'src/app/common/reset-password/reset-password.component';
import { LoginResponse } from 'src/interface/user';
import { UniversalStorageService } from '../../services/universal-storage.service';
import { ReCaptcha2Component } from 'ngx-captcha';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    error: string | null;
    success: string | null;
    vaildCaptcha: false;
    loginSuccess = false;
    @Input() name: string;
    token: string | undefined;

    @ViewChild('emailField') emailField: string;
    @ViewChild('passwordField') passwordField: string;
    username: string;
    recaptchaToken: string;

    constructor(
        private userService: UserService,
        private userTokenService: UserTokenService,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public sharedService: SharedService,
        private modalService: NgbModal,
        private storageService: UniversalStorageService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private router: Router
    ) {
        this.siteKey = '6LeD-JkoAAAAAEHHBdGNm3Ikyv1rWy0a-lZyWQ2s';
    }

    @ViewChild('captchaElem', { static: false })
    captchaElem: ReCaptcha2Component;

    public readonly siteKey = '6LeD-JkoAAAAAEHHBdGNm3Ikyv1rWy0a-lZyWQ2s'; //'6LdI5JYoAAAAAJ5apC89TCAqrA3J1A472QHbYQSV';

    email = '';
    password = '';
    loginFormSubmitted = false;

    submitted = false;
    loginForm = new FormGroup({
        email: new FormControl(null, [Validators.required]),
        password: new FormControl(null, [Validators.required]),
        recaptcha: new FormControl(null, [Validators.required]),
    });

    public executeImportantAction(): void {
        this.recaptchaV3Service
            .execute('importantAction')
            .subscribe((token) => {
                this.recaptchaToken = token;
                this.onLogin(this.recaptchaToken);
            });
    }

    async onLogin(recaptchaToken) {
        this.submitted = true;
        this.loginFormSubmitted = true;

        // Clear previous error and success messages
        this.error = '';
        this.success = '';

        if (this.loginForm.invalid) {
            this.loginSuccess = false;
            return;
        }

        const emailControl = this.loginForm.get('email');
        const username = emailControl ? emailControl.value || '' : '';
        const passwordControl = this.loginForm.get('password');
        const pwd = passwordControl ? passwordControl.value || '' : '';
        const password = btoa(pwd);

        for (const control of Object.keys(this.loginForm.controls)) {
            this.loginForm.controls[control].markAsTouched();
        }
        try {
            const response: LoginResponse = await this.userService.login({
                username: username,
                password: password,
                recaptchatoken: recaptchaToken,
            });

            if (response.status === 200) {
                this.username = response.user.first_name;
                this.userTokenService.setToken(response.token);
                const username = this.username;
                this.sharedService.setUsername(username);
                this.storageService.setItem('loggedInUsername', username);
                this.loginSuccess = true;
                this.success = 'Logged in successfully';
                // Automatically dismiss the modal after 3 seconds
                setTimeout(() => {
                    this.activeModal.dismiss();
                    this.router.navigateByUrl('user/user-profile/edit-profile');
                }, 1000); // 1000 milliseconds (1 second)
            } else {
                // Handle other response statuses here (if needed)
                this.loginSuccess = false;
                // Show appropriate error message to the user
                if (response.status === 401) {
                    this.error = 'Invalid credentials.';
                }
                if (response.status === 500) {
                    this.error = response['error'];
                } else {
                    //this.error = response.error;
                    this.error = response['error'] || 'Unknown error occurred.';
                }
            }
        } catch (error) {
            this.loginSuccess = false;
            this.error = 'Unknown error occurred123';
        }
    }

    get apple() {
        return false;
    }

    get formfields() {
        return this.loginForm.controls;
    }

    eventHandler(event) {
        if (event.keyCode == 13) {
            // this.onLogin();
            this.executeImportantAction();
        }
    }

    public hidePassword = true;
    hideShowPassword() {
        this.hidePassword = !this.hidePassword;
    }

    moveToResetPassword() {
        this.activeModal.dismiss();
        const modalRef = this.modalService.open(ResetPasswordComponent);
        modalRef.componentInstance.name = 'World';
    }

    showNewPassword = false;
    showConfirmPassword = false;

    togglePasswordVisibility(field: string): void {
        if (field === 'password') {
            this.showNewPassword = !this.showNewPassword;
        }
    }
}
